<template>
    <div>
        <div class="ef-node-form">
            <div class="ef-node-form-header">
                编辑
            </div>
            <div class="ef-node-form-body">
                <el-form :model="node" ref="dataForm" label-width="80px" v-show="type === 'node'">
                    <!-- <el-form-item label="类型">
                        <el-input v-model="node.type" :disabled="true"></el-input>
                    </el-form-item> -->
                    <el-form-item label="名称">
                        <el-input v-model="node.name" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="left坐标">
                        <el-input v-model="node.left" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="top坐标">
                        <el-input v-model="node.top" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="ico图标">
                        <el-input v-model="node.ico" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="node.state" placeholder="请选择">
                            <el-option
                                    v-for="item in stateList"
                                    :key="item.state"
                                    :label="item.label"
                                    :value="item.state">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="text-align:center;">
                        <el-button type="primary" icon="el-icon-check" @click="save" plain>保存</el-button>
                    </el-form-item>
                </el-form>

                <el-form :model="line" ref="dataForm" v-show="type === 'line'">
                    <el-form-item label="条件" label-width="80px">
                        <el-select v-model="line.label" clearable placeholder="请选择" multiple filterable collapse-tags>
                          <el-option v-for="item in labelList" :key="item.name" :label="item.name" :value="item.name" :title="item.name"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="text-align:center;">
                        <el-button type="primary" icon="el-icon-check"  @click="saveLine" plain>保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>

</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  props: {
    // 来自 engine/index.vue 的 company.companySelected
    companyId: {
    },
    // 来自 engine/index.vue 的 group.groupSelected
    groupId: {
    }
  },
  data() {
    return {
      visible: true,
      // node 或 line
      type: 'node',
      node: {},
      line: {},
      data: {},
      stateList: [{
        state: 'success',
        label: '成功'
      }, {
        state: 'warning',
        label: '警告'
      }, {
        state: 'error',
        label: '错误'
      }, {
        state: 'running',
        label: '运行中'
      }],
      labelList: [],
      labelSelected: null
    };
  },
  mounted() {
    this.labelSearch();
  },
  watch: {
    groupId() {
      this.labelSearch();
    }
  },
  methods: {
    /**
    * 表单修改，这里可以根据传入的ID进行业务信息获取
    * @param data
    * @param id
    */
    nodeInit(data, id) {
      this.type = 'node';
      this.data = data;
      data.nodeList.forEach((node) => {
        if (node.id === id) {
          this.node = cloneDeep(node);
        }
      });
    },
    lineInit(line) {
      this.type = 'line';
      this.line = line;
    },
    // 修改连线
    saveLine() {
      this.$emit('setLineLabel', this.line.from, this.line.to, this.line.label);
    },
    save() {
      this.data.nodeList.forEach((node) => {
        if (node.id === this.node.id) {
          node.name = this.node.name;
          node.left = this.node.left;
          node.top = this.node.top;
          node.ico = this.node.ico;
          node.state = this.node.state;
          this.$emit('repaintEverything');
        }
      });
    },
    labelSearch() {
      if (this.companyId == null || this.companyId === undefined || this.companyId === '') {
        return;
      }
      if (this.groupId == null || this.groupId === undefined || this.groupId === '') {
        return;
      }
      this.$ajax({
        url: '/label/getLabelParams',
        method: 'POST',
        data: {
          companyId: this.companyId,
          groupId: this.groupId
        }
      }).then((res) => {
        this.labelList = res.data;
      });
    }
  }
};
</script>

<style>
    .el-node-form-tag {
        position: absolute;
        top: 50%;
        margin-left: -15px;
        height: 40px;
        width: 15px;
        background-color: #fbfbfb;
        border: 1px solid rgb(220, 227, 232);
        border-right: none;
        z-index: 0;
    }
</style>



// WEBPACK FOOTER //
// src/page/main/collection/engine/ef/node_form.vue